import React, { useState, useRef } from 'react';
import './TicTacToe.css';
import circle_icon from '../Assets/circle.png';
import cross_icon from '../Assets/cross.png';

const TicTacToe = () => {
  const [board, setBoard] = useState(Array(9).fill(''));
  const [count, setCount] = useState(0);
  const [lock, setLock] = useState(false);
  const [scores, setScores] = useState({ x: 0, o: 0 });
  const [gameOver, setGameOver] = useState(false);
  const [playerChoice, setPlayerChoice] = useState({ playerX: null, playerO: null });
  const [playersSelected, setPlayersSelected] = useState(false);
  const titleRef = useRef(null);

  const selectPlayer = (choice) => {
    setPlayerChoice(choice);
    setPlayersSelected(true);
  };

  const toggle = (index) => {
    if (lock || board[index]) {
      return;
    }

    const newBoard = board.slice();
    newBoard[index] = count % 2 === 0 ? playerChoice.playerX : playerChoice.playerO;
    setBoard(newBoard);
    setCount(count + 1);
    checkWin(newBoard);
  };

  const checkWin = (newBoard) => {
    const winPatterns = [
      [0, 1, 2], [3, 4, 5], [6, 7, 8], // Rows
      [0, 3, 6], [1, 4, 7], [2, 5, 8], // Columns
      [0, 4, 8], [2, 4, 6] // Diagonals
    ];

    for (let pattern of winPatterns) {
      const [a, b, c] = pattern;
      if (newBoard[a] && newBoard[a] === newBoard[b] && newBoard[a] === newBoard[c]) {
        won(newBoard[a]);
        return;
      }
    }

    if (count === 8) {
      titleRef.current.innerHTML = 'Draw!';
      setLock(true);
      setGameOver(true);
    }
  };

  const won = (winner) => {
    setLock(true);
    setScores((prevScores) => ({
      ...prevScores,
      [winner]: prevScores[winner] + 1,
    }));
    setGameOver(true);
    titleRef.current.innerHTML = `Congratulations: <img src=${winner === 'x' ? cross_icon : circle_icon} alt="${winner} icon" />`;
  };

  const resetGame = () => {
    setBoard(Array(9).fill(''));
    setCount(0);
    setLock(false);
    setGameOver(false);
    titleRef.current.innerHTML = 'Tic Tac Toe Game In <span>React</span>';
  };

  const clearScores = () => {
    setScores({ x: 0, o: 0 });
    resetGame();
  };

  const resetAll = () => {
    clearScores();
    setPlayersSelected(false);
    setPlayerChoice({ playerX: null, playerO: null });
  };

  return (
    <div className='container'>
      <h1 className="title" ref={titleRef}>Tic Tac Toe Game In <span>React</span></h1>
      {!playersSelected ? (
        <div className="player-selection">
          <h2>Select Your Players</h2>
          <div>
            <button onClick={() => selectPlayer({ playerX: 'x', playerO: 'o' })}>Player 1: Cross, Player 2: Circle</button>
            <button onClick={() => selectPlayer({ playerX: 'o', playerO: 'x' })}>Player 1: Circle, Player 2: Cross</button>
          </div>
        </div>
      ) : (
        <>
          {gameOver && (
            <div className="scoreboard">
              <p>Player X (Cross): {scores.x}</p>
              <p>Player O (Circle): {scores.o}</p>
            </div>
          )}
          <div className="board">
            {[0, 1, 2].map((row) => (
              <div key={row} className={`row${row + 1}`}>
                {[0, 1, 2].map((col) => {
                  const index = row * 3 + col;
                  return (
                    <div key={index} className="boxes" onClick={() => toggle(index)}>
                      {board[index] && <img src={board[index] === 'x' ? cross_icon : circle_icon} alt={board[index]} />}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
          <button className="reset" onClick={resetGame}>New Game</button>
          <button className="clear-scores" onClick={clearScores}>Clear Scores</button>
          <button className="clear-scores" onClick={resetAll}>Reset All</button>
        </>
      )}
    </div>
  );
};

export default TicTacToe;
